import React, { useRef, useState } from "react";
import { object, func, string } from "prop-types";
import get from "lodash/get";

import TopArrowContainer from "../../atoms/TopArrowContainer";
import ContributorImage from "../../atoms/ContributorImage";

import { emailLink } from "../../helper/api";

import "./memberNotVerifiedView.m.css";

const MemberNotVerifiedView = ({ member, closeView, src, storyUrl }) => {
  const viewRef = useRef(null);
  const pendingMessage = "Your email verification is pending.";
  const [initMessage, setInitMessage] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const verifyEmailAccount = () => {
    setLoading(true);
    emailLink(member.email, `${storyUrl}`).then(() => {
      setInitMessage(false);
      setLoading(false);
      setShowButton(false);
    });
  };

  const customStyleName = `${src ? `${src}-wrapper` : ""} top-arrow-container-wrapper`;

  const customButtonStyle = `${loading ? "wrapper-loading" : ""}`;

  return (
    <div styleName={customStyleName} ref={viewRef}>
      <TopArrowContainer closeView={closeView} className={src ? "no-top-arrow" : ""}>
        <div styleName="wrapper">
          <div styleName={`profile`}>
            <div styleName="image-name-wrapper">
              <ContributorImage authorObj={member} memberProfilePic={true} />
              <span styleName="name">{member.name}</span>
            </div>
          </div>

          <div styleName={`not-verified`}>
            {initMessage ? (
              <span className="pending-message">{pendingMessage}</span>
            ) : (
              <span className="sent-message">
                We have sent an activation email to you at{" "}
                <a aria-label=" We have sent an activation email to you at" styleName="email-link">
                  {get(member, ["email"], "")}
                </a>
                . Please check your email box.
              </span>
            )}
            {showButton && (
              <span styleName={`email-verify ${customButtonStyle}`} onClick={verifyEmailAccount}>
                VERIFY
              </span>
            )}
          </div>
        </div>
      </TopArrowContainer>
    </div>
  );
};

MemberNotVerifiedView.propTypes = {
  member: object.isRequired,
  closeView: func,
  navigateToPage: func,
  logout: func,
  src: string,
  storyUrl: string,
};

export default MemberNotVerifiedView;
